import React from 'react';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';

import { getPatientFieldSet, getProviderFieldSet } from '../profileFieldSet';
import FieldsetList from '../../ProfileLayout/FieldSetList';
import { PUBLIC_PROFILE } from '../../../constants/routes';
import styles from '../styles.styl';

const PublicProfileInfoImpl = ({
  intl: { formatMessage },
  profile: { id, primaryPatientProfile, primaryProviderProfile } = {},
}) => {
  if (!(primaryPatientProfile || primaryProviderProfile)) {
    browserHistory.push(`${PUBLIC_PROFILE}/${id}`);
    return null;
  }

  const fieldSet = primaryPatientProfile
    ? getPatientFieldSet(primaryPatientProfile)
    : getProviderFieldSet(primaryProviderProfile);

  return (
    <div styleName="content content--profile content--info">
      <div styleName="info">
        <div>
          <FieldsetList fieldSetList={fieldSet(formatMessage)} disabled />
        </div>
      </div>
    </div>
  );
};

PublicProfileInfoImpl.propTypes = {
  intl: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

export const PublicProfileInfo = compose(
  injectIntl,
  CSSModules(styles, { allowMultiple: true }),
)(PublicProfileInfoImpl);



// WEBPACK FOOTER //
// ./src/components/PublicProfile/ProfileInfo/index.jsx